<template>
  <div class="overlay-container" v-if="showContactPopup" @click="setContactPopup(false)">
    <div class="contact-modal" @click.stop>
      <div class="modal-content" :class="!success ? 'show-bg': ''">
        <div v-if="!success">
          <div class="form-header">
            <h4>Almost there!</h4>
            <h2>You're a step away from unlocking the free trial!</h2>
          </div>
          <form class="contact-form">
            <div :class="['form-group', (formFields.name.showError ? 'error-field' : '')]">
              <label class="field-label" for="name">Full Name</label>
              <input
                :class="[!formFields.name.showError ? 'tick-icon' : null]"
                type="text"
                v-model="formData.name"
                name="name"
                id="name"
                placeholder="Enter your full name"
                autocomplete="off"
                autofocus
              />
              <p v-if="formFields.name.showError" class="error-msg">{{formFields.name.errorMsg}}</p>
            </div>
            <div :class="['form-group', (formFields.phone.showError ? 'error-field' : '')]">
              <label class="field-label" for="phone">Phone Number</label>
              <input
                :class="['MobileNumber',!formFields.phone.showError ? 'tick-icon' : null]"
                type="tel"
                ref="phoneInput"
                name="phone"
                id="phone"
                placeholder="Enter your phone number"
                autocomplete="off"
                autofocus
                style="width: 100%;"
              />
              <p v-if="formFields.phone.showError" class="error-msg">{{formFields.phone.errorMsg}}</p>
            </div>
            <div v-if="showEmailField" :class="['form-group', (formFields.email.showError ? 'error-field' : '')]">
              <label class="field-label" for="email">Work Email</label>
              <input :class="[!formFields.email.showError ? 'tick-icon' : null]" type="email" v-model="formData.email"
                name="email" id="email" placeholder="Enter your work email" autocomplete="off"
                @input="checkEmailTypo" @blur="checkEmailTypo" />
              <p v-if="formFields.email.showError" class="error-msg">{{ formFields.email.errorMsg }}</p>
              <p v-else-if="emailSuggestion" class="suggestion-msg">
                Did you mean
                <a @click="acceptSuggestion" class="suggestion-link">{{ emailSuggestion }}</a>?
              </p>
            </div>
            <div class="form-group consent">
              <p>
                By clicking Submit, you agree to our
                <a href="/terms" target="_blank">Terms & Conditions</a> and
                <a href="/privacy" target="_blank">Privacy Policy</a>
              </p>
            </div>
            <button type="button" class="submit-btn" @click="submit()">
              Submit
            </button>
          </form>
        </div>
        <div v-else class="success-block">
          <svg><use v-bind="{'xlink:href':'#success-illustration-2'}"></use></svg>
          <p>Our business team will get in touch with you!</p>
          <button type="button" class="close-btn" @click="setContactPopup(false)">
            Okay, Thanks!
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '~intl-tel-input/build/css/intlTelInput.css';

  .overlay-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(26, 26, 26, 0.70);
    z-index: var(--slidein-z-index);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .contact-modal {
    background:#ffffff;
    max-width: size(600);
    width: 100%;
    margin: size(20) auto;
    max-height: 80vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    border-radius: size(8);
    background: #FFF;
    box-shadow: 0 size(4) size(20) 0 rgba(0, 0, 0, 0.08);
    animation: slideup 0.3s ease-in-out;

    @keyframes slideup {
      0% {
        opacity: 0;
        transform: translateY(30px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .modal-content {
      padding: size(48);
      &.show-bg {
        background: url('../../assets/campaign/O.svg') no-repeat;
        background-position: top right;
      }

      .form-header {
        margin-bottom: size(32);
        white-space: normal;

        h4 {
          color: var(--rs-black-color);
          font-size: size(16);
          font-weight: 400;
          padding-bottom: size(8);
        }
        h2 {
          color: var(--rs-black-color);
          font-size: size(24);
          font-weight: 700;
          max-width: size(400);
          line-height: size(32);
          text-wrap: wrap;
        }
      }

      .contact-form {
        .form-group {
          margin-bottom: size(20);

          &>.error-msg {
            color: var(--onboard-error-color);
            font-size: size(12);
            padding: size(10) 0;
          }

          label {
            display: block;
            color: var(--rs-black-color);
            font-size: size(15);
            font-weight: 500;
            padding-bottom: size(8);
          }

          input {
            display: block;
            width: 100%;
            box-sizing: border-box;
            padding: size(20);
            border: 1px solid #C0C0C0;
            border-radius: size(6);
            font-size: size(14);
            color: var(--rs-black-color);

            &:focus {
              outline: none;
              border-color: #007bff;
            }

            &::placeholder {
              color: #8D8D8D;
            }
          }
          &.consent {
            margin-bottom: size(32);
            width: 100%;
            white-space: normal;
            p {
              color: var(--rs-black-color);
              font-size: size(12);
              font-weight: 400;
              line-height: size(20);
            }
            a {
              text-decoration: underline;
            }
          }
        }

        .submit-btn {
          width: 100%;
          font-size: size(12);
          line-height: size(14);
          font-weight: bold;
          padding: size(16);
          display: inline-block;
          background: var(--rs-cta-blue-color);
          border: size(1) solid var(--rs-cta-blue-color);
          border-radius: size(6);
          color: var(--rs-white-color);
          cursor: pointer;
          @media screen and (min-width: $breakpoint-md) {
            font-size: size(15);
            line-height: size(18);
          }
          @media screen and (min-width: $breakpoint-lg) {
            padding: size(20) size(30);
          }
          &:hover {
            &:after {
              @include move-animation;
            }
          }
          &:after {
            content: '';
            border-width: 0 size(2) size(2) 0;
            display: inline-block;
            padding: size(2.2);
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            margin-left: size(5);
            vertical-align: middle;
            border: solid var(--rs-white-color);
            border-width: 0 size(2) size(2) 0;
            vertical-align: middle;
          }
        }
      }
      .success-block {
        text-align: center;
        p {
          font-size: size(24);
          font-weight: 700;
          line-height: size(36);
          text-wrap: wrap;
          padding: size(24) 0;
        }

        button {
          padding: size(20) size(40);
          color: #0055BF;
          font-size: size(15);
          font-weight: 700;
          border-radius: size(6);
          border: 1px solid #0055BF;
          cursor: pointer;
          outline: none;
        }
      }
    }
  }

  @media screen and (max-width: $breakpoint-sm) {
    .contact-modal {
      margin: size(10);
      max-width: size(300);
    }

    .contact-modal .modal-content {
      padding: 0 size(20) size(20);
    }
  }
    .suggestion-msg {
      margin-top: size(4);
      font-size: size(12);
      background: #7e616100;
      padding: size(6) size(10);
      white-space: normal;
      .suggestion-link {
        color: #0066CC;
        font-weight: 600;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          color: #0052A3;
        }
      }
    }
</style>
<script>
import intlTelInput from 'intl-tel-input';
import { WebPage } from '@/store/modules/page';
import { FieldHandler } from '@/core/utils/formModels';
import CookieManager from '@/core/utils/cookieManager';
import * as EmailValidator from 'email-validator';
import Mailcheck from 'mailcheck';


export default {
  name: 'ContactComponent',
  props: {
    showContactPopup: {
      type: Boolean,
      default: false,
    },
    email: {
      type: String,
      default: '',
    },
    showEmailField: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      scrollY: 0,
      iti: null,
      formData: {
        name: '',
        phone: '',
        email: this.email,
        campaign_id: '',
        campaign_source: '',
      },
      errorMessage: null,
      formContent: true,
      success: false,
      showLoader: false,
      formFields: {
        name: new FieldHandler({
          errorMsg: 'Please enter a full name.',
        }),
        phone: new FieldHandler({
          errorMsg: 'Please enter a valid phone number.',
        }),
        email: new FieldHandler({
          errorMsg: 'Please enter a valid email address.',
        }),
        response: new FieldHandler({
          errorMsg: 'Something went wrong!',
        }),
      },
      emailSuggestion: null,
    };
  },
  mounted() {
    this.initPhoneInput();
    if (this.showContactPopup) {
      this.lockScroll();
    }
  },
  beforeDestroy() {
    this.unlockScroll();
  },
  methods: {
    lockScroll() {
      this.scrollY = window.pageYOffset;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollY}px`;
      document.body.style.width = '100%';
    },

    unlockScroll() {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, this.scrollY);
    },
    initPhoneInput() {
      const input = this.$refs.phoneInput;
      if (input) {
        this.iti = intlTelInput(input, {
          initialCountry: 'in',
          preferredCountries: ['in', 'is', 'gb'],
          separateDialCode: true,
          utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js',
        });

        this.$nextTick(() => {
          const wrapper = input.closest('.iti') || input.parentElement.querySelector('.iti') || input.parentElement;
          if (wrapper) {
            wrapper.style.display = 'block';
            wrapper.style.width = '100%';
          }
        });
        const dropdown = document.querySelector('.iti__country-list');
        if (dropdown) {
          dropdown.style.width = '100%';
          dropdown.style.minWidth = '300px';
          dropdown.style.left = '-1px';
          dropdown.style.borderRadius = '0.375rem';
          if (window.innerWidth <= 500) {
            dropdown.style.minWidth = '250px';
          }
        }
        const selectedFlag = document.querySelector('.iti--separate-dial-code .iti__selected-flag');
        if (selectedFlag) {
          selectedFlag.style.backgroundColor = 'white';
          selectedFlag.style.padding = '0 6px 0 8px';
          selectedFlag.style.borderRadius = '0.375rem';
        }
      }
    },
    setContactPopup(val) {
      this.$emit('update:showContactPopup', val);
      if (!val) {
        this.resetForm();
        this.unlockScroll();
      } else {
        this.lockScroll();
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        phone: '',
      };
      if (this.iti) {
        this.iti.setNumber('');
      }
    },
    async submit() {
      if (!this.validateForm()) {
        return;
      }
      if (this.showEmailField) {
        if (!this.formData.email.trim()) {
          this.formFields.email.showError = true;
          this.formFields.email.errorMsg = 'Please enter your work email address.';
          return;
        }
        if (!EmailValidator.validate(this.formData.email)) {
          this.formFields.email.showError = true;
          this.formFields.email.errorMsg = 'Please enter a valid email address.';
          return;
        }
        await new Promise((resolve) => {
          Mailcheck.run({
            email: this.formData.email,
            suggested: (suggestion) => {
              this.emailSuggestion = suggestion.full;
              resolve(true);
            },
            empty: () => {
              resolve(false);
            },
          });
        });
        const domain = this.formData.email.split('@')[1];
        try {
          const response = await fetch(`https://dns.google/resolve?name=${domain}&type=MX`);
          const data = await response.json();
          if (!data.Answer || data.Answer.length === 0) {
            const proceed = window.confirm(
              /* eslint-disable-next-line max-len */
              'We couldn\'t verify this email domain. Please recheck your email. Click OK if you\'re sure it\'s correct, or Cancel to go back.',
            );
            if (!proceed) {
              return;
            }
          }
        } catch (error) {
          this.formFields.email.showError = true;
          this.formFields.email.errorMsg = 'Unable to verify email domain. Please try again.';
          return;
        }
      }
      this.formData.action = 'campaign_lead_action';
      this.formData.phone = this.iti.getNumber();

      if (CookieManager.getItem('source_id')) {
        this.formData.campaign_id = CookieManager.getItem('source_id');
      }
      if (CookieManager.getItem('source_medium')) {
        this.formData.campaign_source = CookieManager.getItem('source_medium');
      }
      WebPage.postCampaignDetails(this.$apiInstance, this.formData)
        .then((resp) => {
          if (resp) {
            this.success = true;
            this.formContent = false;
          } else {
            this.success = false;
            this.formContent = true;
            this.formFields.response.showError = true;
            this.formFields.response.errorMsg = 'Something went wrong.';
            this.showLoader = false;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    validateForm() {
      let count = 0;
      const namePattern = /^[A-Za-z][A-Za-z\s.'-]{1,}$/;
      if (!this.formFields.name.validateField(this.formData.name) || !namePattern.test(this.formData.name.trim())) {
        this.formFields.name.showError = true;
        this.formFields.name.errorMsg = 'Please enter a valid full name.';
        count += 1;
      } else {
        this.formFields.name.showError = false;
      }
      if (!this.iti || !this.iti.isValidNumber()) {
        this.formFields.phone.showError = true;
        count += 1;
      } else {
        this.formFields.phone.showError = false;
      }
      if (this.showEmailField) {
        if (!this.formData.email.trim()) {
          this.formFields.email.showError = true;
          this.formFields.email.errorMsg = 'Please enter your work email address.';
          count += 1;
        } else if (!EmailValidator.validate(this.formData.email)) {
          this.formFields.email.showError = true;
          this.formFields.email.errorMsg = 'Please enter a valid email address.';
          count += 1;
        } else {
          this.formFields.email.showError = false;
        }
      }
      return (count === 0);
    },

    checkEmailTypo() {
      this.formFields.email.showError = false;
      if (!this.formData.email.trim()) {
        this.emailSuggestion = null;
        return;
      }
      Mailcheck.run({
        email: this.formData.email,
        suggested: (suggestion) => {
          this.emailSuggestion = suggestion.full;
        },
        empty: () => {
          this.emailSuggestion = null;
        },
      });
    },

    acceptSuggestion() {
      this.formData.email = this.emailSuggestion;
      this.emailSuggestion = null;
      this.formFields.email.showError = false;
    },
  },
  watch: {
    showContactPopup(newVal) {
      if (newVal) {
        this.lockScroll();
        this.$nextTick(() => {
          this.initPhoneInput();
        });
      } else {
        this.unlockScroll();
        this.resetForm();
      }
    },
  },
};
</script>
